import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {Router, Switch, Route} from "react-router-dom";
import history from "./history.ts";
import TicTacToe from "./tictactoe.tsx";
import TrickyTicTacToe from "./trickytictactoe.tsx";
import ThisOrThat from "./thisorthat.tsx";
import ColourChallenge from "./colourchallenge.tsx";
import LayoutInspiration from "./layoutInspiration.tsx"

import Homepage from "./homepage.tsx"
import About from "./about.tsx"
import Recipe from './recipe.tsx';
import Pick5 from './pick5.tsx';
import Checklist from './checklist.tsx';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <a href="/"><img src="/webbanner.jpg" style={{width:"100%"}} alt="Snap Scrap Repeat"></img></a>
    <Router history={history}>
        <Switch>
          <Route path="/recipe"><Recipe /></Route>
          <Route path="/pick5"><Pick5 /></Route>
          <Route path="/thisorthat"><ThisOrThat /></Route>
          <Route path="/tictactoe"><TicTacToe /></Route>
          <Route path="/trickytictactoe"><TrickyTicTacToe /></Route>
          <Route path="/colourchallenge"><ColourChallenge /></Route>
          <Route path="/layout"><LayoutInspiration /></Route>
          <Route path="/about"><About /></Route>
          <Route path="/photohunt"><Checklist /></Route>
          <Route path="/"><Homepage /></Route>
        </Switch>
    </Router>
     </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
